import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { useDraftsSelect } from '../../hooks/useDraftsSelect';
import { getActiveSection } from '../../selectors/studio';
import { StudioSection } from '../../types/store';
import DefaultDeviationList from './presets/DeviationList';
import TierDeviationList from './presets/TierDeviationList';
import PcpDeviationList from './presets/PcpDeviationList';
import ExclusiveDeviationList from './presets/ExclusiveDeviationList';
import CommissionDeviationList from './presets/CommissionDeviationList';
import OriginalDeviationList from './presets/OriginalDeviationList';
import PremiumGalleryList from './presets/PremiumGalleryList';
import ApplicationList from './presets/ApplicationList';

export interface Props {
  deviations: PapiDeviation[];
  selectProps: ReturnType<typeof useDraftsSelect>;
}

const StudioDeviationList: FC<Props> = props => {
  const activeSection = useSelector(getActiveSection);
  switch (activeSection) {
    case StudioSection.PRODUCTS_TIER:
    case StudioSection.PRODUCTS_TIER_UNLISTED:
      return <TierDeviationList {...props} />;
    case StudioSection.PRODUCTS_PCP:
    case StudioSection.PRODUCTS_PCP_UNLISTED:
      return <PcpDeviationList {...props} />;
    case StudioSection.PRODUCTS_EXCLUSIVE:
    case StudioSection.PRODUCTS_EXCLUSIVE_UNLISTED:
      return <ExclusiveDeviationList {...props} />;
    case StudioSection.PRODUCTS_COMMISSION:
      return <CommissionDeviationList {...props} />;
    case StudioSection.PRODUCTS_ORIGINAL:
    case StudioSection.PRODUCTS_ORIGINAL_UNLISTED:
      return <OriginalDeviationList {...props} />;
    case StudioSection.PRODUCTS_PREMIUM_GALLERY:
      // special case because it doesn't actually use the deviations dataset
      return <PremiumGalleryList />;
    case StudioSection.APPS:
    case StudioSection.APPS_UNLISTED:
      return <ApplicationList {...props} />;
    default:
      return <DefaultDeviationList {...props} />;
  }
};

StudioDeviationList.displayName = 'StudioDeviationList';
export default StudioDeviationList;
